

const styled = {
    input: {
        minWidth: '100px',// Adjust the width as needed
        height: '18%', // Adjust the height as needed
        padding: '3%',
        
    },
    inputImg: {
        minWidth: '100px',// Adjust the width as needed
        height: '15%', // Adjust the height as needed
        paddingTop: '0%'
    },
    inputs: {
        minWidth: '100px',// Adjust the width as needed
        height: '18%', // Adjust the height as needed
        padding: '8%',

    },
    txtArea: {
        minWidth: '300px',// Adjust the width as needed
        height: '40px', // Adjust the height as needed
        padding: '10%',

    },
    inputTable: {
        minWidth: '60px',// Adjust the width as needed
        height: '18%', // Adjust the height as needed
        padding: '3%',

    },
    inputTables: {
        minWidth: '80px',// Adjust the width as needed
        height: '18%', // Adjust the height as needed
        padding: '3%',

    },
    inputDate: {
        minWidth: '100px',// Adjust the width as needed
        height: '18%', // Adjust the height as needed
        padding: '2%',
    },
    cutDate: {
        Width: '70px',// Adjust the width as needed
        height: '18%', // Adjust the height as needed
        padding: '2%',
    },
    dropdownInput: {
        minWidth: '200px', // Adjust the width as needed
        height: '60%', // Adjust the height as needed
        display: 'flex',
        alignItems: 'center',
        padding: '0'

    },
    stockInput: {
        Width: '80%',// Adjust the width as needed
        padding: '2%',
    },


};

export default styled;

export const inputStyles = {
    height: '35px', // Set your desired height
    width: '240px', // Set your desired width
    background: 'none',
};


export const inputImages = {
    height: '35px', // Set your desired height
    width: '250px', // Set your desired width
    background: 'none',
};

export const inputStyless = {
    height: '35px', // Set your desired height
    width: '200px', // Set your desired width

};

export const inputStyle11 = {
    height: '40px', // Set your desired height
    width: '170px', // Set your desired width
    padding: '2px',


};

export const inputNumbers = {
    height: '35px', // Set your desired height
    width: '100px',

};
export const inputNumbersmall = {
    height: '30px', // Set your desired height
    width: '60px',

};
export const cutDates = {
    height: '35px', // Set your desired height
    width: '200px', // Set your desired width
    background: 'none',
};


export const stockNumber = {
    height: '35px', // Set your desired height
    width: '100px', // Set your desired width
    background: 'none',
    marginTop: '2%'
};